import gql from "graphql-tag";
export const CHANGE_PASSWORD_MUTATION = gql`
  mutation changePassword($current_password: String!, $new_password: String!) {
    changePassword(current_password: $current_password, new_password: $new_password) 
  }
`;